<template>
  <section class="feature">
    <div class="container">
      <a-typography-title :level="1">
        私有化部署 vs SaaS版核心差异
      </a-typography-title>
      <a-table class="table_box" :rowClassName="(record: any, index: number) => (index % 2 === 0 ? 'table_striped' : 'table_column')" :columns="expand.columns"
        :data-source="expand.data"  bordered :pagination="false">
      </a-table>
    </div>
  </section>
</template>
    <script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";
export default {
  name: "product_feature",
  data(): DataInterface {
    return {
      expand: {
        columns: [
          {
            title: "功能纬度",
            dataIndex: "function",
            key: "function",
            align: "center",
          },
          {
            title: "私有化版本",
            dataIndex: "private",
            key: "private",
            align: "center",
          },
          {
            title: "SaaS版本",
            dataIndex: "saas",
            key: "saas",
            align: "center",
          },
        ],
        data: [
          {
            function: "数据存储",
            private: "企业自主管理",
            saas: "云端集中存储",
          },
          {
            function: "定制权限",
            private: "源码级开放",
            saas: "基础功能配置",
          },
          {
            function: "响应速度",
            private: "本地毫秒级响应",
            saas: "云端1-3秒响应",
          },
          {
            function: "合规性",
            private: "支持行业特殊认证",
            saas: "通用合规标准",
          },
        ],
      },
    };
  },
  methods: {},
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";
@image: "@{src_image}page/productInfraPilot/";

.feature {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_9;
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    text-align: center;
    .table_box {
      margin-top: 40px;
    }
    &:deep(.table_striped) {
      background-color: #f5f5f5;
    }
    &:deep(.table_column) {
      background-color: #fff;
    }
    &:deep(.ant-table-thead) tr th {
      background-color: #fff;
    }
  }
}
</style>